import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchPropertiesDone = (_, { payload }) => {
  
  return [
    ...payload,
  ];
};

const fetchPropertyByIdDone = (properties, { payload }) => {
  // return [
  //   ...properties,
  //   payload,
  // ];
  return properties.map( data => {
    if( data.id === payload.id ){
      return payload
    }else{
      return data
    }
  })
};

// const fetchPropertySuitesDone = (properties, { payload }) => {
//   return properties.map(p => {
//     if (p.id === payload.id) {
//       return {
//         ...p,
//         suites: payload.suites,
//       };
//     }
//     return p;
//   });
// };

const fetchPropertyNotesDone = (properties, { payload }) => {
  return properties.map(p => {
    if (p.id === payload.id) {
      return {
        ...p,
        notes: payload.notes,
      };
    }
    return p;
  });
};

const fetchPropertyDocumentsDone = (properties, { payload }) => {
  return properties.map(p => {
    if (p.id === payload.id) {
      return {
        ...p,
        documents: payload.documents,
      };
    }
    return p;
  });
};

const fetchPropertyServiceRequestsDone = (properties, { payload }) => {
  return properties.map(p => {
    if (p.id === payload.id) {
      return {
        ...p,
        serviceRequests: payload.serviceRequests,
      };
    }
    return p;
  });
};

const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_PROPERTIES_DONE]: fetchPropertiesDone,
  [TYPES.FETCH_PROPERTY_BY_ID_DONE]: fetchPropertyByIdDone,
  [TYPES.FETCH_PROPERTY_DOCUMENTS_DONE]: fetchPropertyDocumentsDone,
  [TYPES.FETCH_PROPERTY_NOTES_DONE]: fetchPropertyNotesDone,
  [TYPES.FETCH_PROPERTY_SERVICE_REQUESTS_DONE]: fetchPropertyServiceRequestsDone,
});
